// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9aab4fcc","453":"e432a093","732":"df57925d","977":"b5e9ef1c"}[chunkId] + ".chunk.js";
};